import React from 'react';
import { Link } from 'react-router-dom';
import './ISO14046.css';

const ISO14046 = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">System Certification</div>
            <h1 className="page-title">ISO 14046 Water Footprint Verification</h1>
            <h2 className="page-subtitle">ISO 14046 Water Footprint Verification: Sustainability and Water Efficiency</h2>
            <div className="page-text-content">
              <p>
                As NQC (Nova Quality Certification Agency), we are delighted to introduce in detail our 
                ISO 14046 Water Footprint Verification service, which is one of the pioneering services 
                of our company in the field of environmental sustainability.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is ISO 14046?</h2>
            <div className="page-text-content">
              <p>
                ISO 14046 is an international standard for measuring, assessing, and reporting water 
                use. This standard guides organizations to understand their impact on water resources, 
                develop sustainable management strategies, and optimize water use.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Importance of ISO 14046 Water Footprint Verification</h2>
            <div className="importance-list">
              <div className="importance-item">
                <h3 className="importance-title">1. Water Efficiency and Conservation</h3>
                <p className="importance-description">
                  ISO 14046 provides guidance to organizations on understanding and reducing water use, 
                  thereby promoting water efficiency and conservation.
                </p>
              </div>
              <div className="importance-item">
                <h3 className="importance-title">2. Sustainable Water Management</h3>
                <p className="importance-description">
                  Through ISO 14046, organizations can develop sustainable water management strategies to 
                  reduce their impact on water resources.
                </p>
              </div>
              <div className="importance-item">
                <h3 className="importance-title">3. Improving Environmental Performance</h3>
                <p className="importance-description">
                  ISO 14046 certification offers companies the opportunity to improve their environmental 
                  performance and optimize water use.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">ISO 14046 Water Footprint Verification Process</h2>
            <div className="process-list">
              <div className="process-item">
                <h3 className="process-title">1. Data Collection and Analysis</h3>
                <p className="process-description">
                  Data related to water use is collected and analyzed.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">2. Risk Assessment</h3>
                <p className="process-description">
                  Environmental impacts and risks associated with water use are assessed.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">3. Reporting</h3>
                <p className="process-description">
                  Data is reported in compliance with standards and presented to stakeholders.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">4. Verification</h3>
                <p className="process-description">
                  An independent verifier checks the compliance of the water footprint verification 
                  process with standards.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">5. Certification</h3>
                <p className="process-description">
                  A successfully verified organization receives the ISO 14046 certification, 
                  demonstrating their efforts in water management.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <div className="page-text-content">
              <p>
                For more information on ISO 14046 Water Footprint Verification and to optimize your 
                environmental activities, feel free to contact us. NQC is here to build a sustainable 
                future together!
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ISO14046;

